export const isDoubaoModel = (model: string) => model.includes('doubao');
